import { createIcon } from '../createIcon';

export const WandMagicIconConfig = {
  name: 'WandMagicIcon',
  height: 512,
  width: 512,
  svgPath: 'M14.1 463.3c-18.7-18.7-18.7-49.1 0-67.9L395.4 14.1c18.7-18.7 49.1-18.7 67.9 0l34.6 34.6c18.7 18.7 18.7 49.1 0 67.9L116.5 497.9c-18.7 18.7-49.1 18.7-67.9 0L14.1 463.3zM347.6 187.6l105-105L429.4 59.3l-105 105 23.3 23.3z',
  yOffset: 0,
  xOffset: 0
};

export const WandMagicIcon = createIcon(WandMagicIconConfig);

export default WandMagicIcon;